"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withLabel = _interopRequireDefault(require("../../../hoc/withLabel"));

var _Checkbox = _interopRequireDefault(require("../../../component/Checkbox"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var Wrapped = (0, _withLabel["default"])(_Checkbox["default"]);
var useStyles = (0, _ThemeProvider.createUseStyles)({
  Label: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 5,
    '&.disabled': {
      opacity: '0.3'
    }
  },
  Checkbox: {
    marginRight: 5
  }
});

var CheckboxWithLabel = function CheckboxWithLabel(_ref) {
  var className = _ref.className,
      wrappedClassName = _ref.wrappedClassName,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "wrappedClassName"]);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(Wrapped, (0, _extends2["default"])({}, rest, {
    wrappedClassName: (0, _classnames["default"])(classes.Checkbox, wrappedClassName),
    className: (0, _classnames["default"])(classes.Label, className)
  }));
};

var _default = CheckboxWithLabel;
exports["default"] = _default;
//# sourceMappingURL=CheckboxWithLabel.js.map